// @External Dependencies
import axios from 'axios'

// @Dependencies
import { apiURL } from '../../../../Config/constants'
import { getToken, axiosError } from '../../../Services'

/**
 * Busca todos los Tipos de direcciones
 *
 * @example
 * ```js
 *    const response = await getAddressTypes()
 * ```
 * @returns Retorna una Lista con los Tipos de Direcciones (id, name)
 */
const getAddressTypes = () => {
  const requestId = 'getAddressTypes'
  return async dispatch => {
    getToken()

    const query = `
      query allAddressTypes{
        allAddressTypes(
          orderBy: id_ASC
        ){
          name
          id
        }
      }
    `

    return axios
      .post(`${apiURL}/graphql`, { query }, { requestId })
      .then(response => {
        const { allAddressTypes } = response.data.data
        if (response.status === 200 && allAddressTypes) {
          return {
            data: allAddressTypes,
            status: {
              success: true,
              detail: 'Petición exitosa'
            }
          }
        } else {
          return {
            data: [],
            status: {
              success: false,
              detail: 'Error al buscar los tipos de direcciones.'
            }
          }
        }
      })
      .catch(err => axiosError(err, requestId, dispatch))
  }
}

export default getAddressTypes
